import _ from "lodash";
import { getIn } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../../utils";
import { CurrencyInput } from "../../CurrencyInput/CurrencyInput";

import "../styles.scss";

export const FormCurrencyField = ({ className, formikProps, name, subTitle, title }) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    await formikProps.setFieldValue(name, event.target.value);
  };

  return (
    <div className={createClassNameString(["FormField-container", className])}>
      {(title || subTitle) && (
        <div className="FormField-header_container" data-public>
          {title && <h3 className="FormField-title">{title}</h3>}
          {subTitle && <h3 className="FormField-subTitle">{subTitle}</h3>}
        </div>
      )}
      <div>
        <CurrencyInput
          // if isTouched is true and errorMessage is truthy (aka not null, "", etc)
          // return errorMessage
          errorMessage={isTouched && errorMessage && errorMessage}
          onChange={handleChange}
          value={value}
        />
      </div>
    </div>
  );
};

FormCurrencyField.propTypes = {
  className: PropTypes.string,
  formikProps: PropTypes.object,
  name: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.string,
};
